<mb-base-modal>
  <div class="content" dialog-content>
    @if (headline) {
      <h5>{{ headline | translate }}</h5>
    }
    @if (text) {
      <p>{{ text | translate }}</p>
    }

    <mb-checkbox class="copy-xl" [checked]="remember" (checkChange)="remember = $event">
      <span>{{ 'REMEMBER' | translate }}</span>
    </mb-checkbox>
    <div class="actions">
      <button class="btn btn-tertiary" (click)="requestCancel.emit()">
        {{ cancelLabel || 'CANCEL' | translate }}
      </button>
      <button class="btn btn-tertiary" (click)="confirm.emit({ remember: remember })">
        {{ confirmLabel || 'CONFIRM' | translate }}
      </button>
    </div>
  </div>
</mb-base-modal>
